export default {
  title: 'Top items',
  columns: {
    name: 'Name',
    quantity: 'Quantity',
    amount: 'Amount',
  },
};
